import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {RegistrationAddDialogData} from "../registration-add-dialog/registration-add-dialog.component";
import {Ofwca} from "../../../shared/interface/ofwca";
import {Contract} from "../../../shared/interface/contract";

export interface RegistrationAddMultipleDialogData {
  ofwcaObject?: Ofwca;
  contractObject?: Contract;
}
@Component({
  selector: 'app-registrations-add-multiple-dialog',
  templateUrl: './registrations-add-multiple-dialog.component.html',
  styleUrls: ['./registrations-add-multiple-dialog.component.scss']
})
export class RegistrationsAddMultipleDialogComponent implements OnInit {
  ofwcaObject?: Ofwca = null;
  contractObject?: Contract = null;
  constructor(
    public dialogRef: MatDialogRef<RegistrationsAddMultipleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RegistrationAddDialogData,
  ) {
    this.ofwcaObject = data.ofwcaObject;
    this.contractObject = data.contractObject;
  }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
